<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">Настройки протоколов</h2>
      <button class="compose btn btn-primary" @click="newRecord()">Загрузить справочники</button>

    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 80%;">Наименование</th>
                <th style="width: 15%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(type, key) in typies2">
                <td>
                  {{key + 1}}
                </td>
                <td>
                  {{type.name}}
                </td>
                <td>
                  <div class="btn-group">
                    <a class="btn btn-sm btn-primary" @click.prevent="viewRecord(type.tag)" href="#"><font-awesome-icon icon="fas fa-eye" /></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Import Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title">Загрузка справочников</h5>
          </div>
          <form @submit.prevent="importJson()">
            <div class="modal-body">
              <div class="form-group">
                <label>Выберите категорию</label>
                <v-select v-model="fieldform.type_id" label="name" :reduce="type => type.id" :options="typies" />
              </div>
              <div class="input-group">
                <input type="file" :key="fileInputKey2" @change="fileUpload2" accept=".json"  class="form-control" style="border: 0;" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Import Modal -->

    <!-- Setting Edit Modal -->
    <div class="modal fade" id="editRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pt-0">
          <div class="modal-header mb-1">
            <h5 class="modal-title">{{show.name}}</h5>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addRecord()">
              <div class="row mb-4">
                <div class="col-8">
                  <input v-model="addform.name" type="text" placeholder="Наименование" class="form-control" required>
                </div>
                <div class="col-4">
                  <button type="submit" class="btn btn-primary">Добавить</button>
                </div>
              </div>
            </form>

            <ul class="list-group" v-if="show.data && show.data.length > 0">
              <li v-for="(list, key) in sortedData" class="list-group-item d-flex justify-content-between align-items-center">
                <b>{{key + 1}}:</b> {{list}}

                <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(list)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
          </div>
        </div>
      </div>
    </div>
    <!-- !Setting Edit Modal -->

  </div>
</template>

<script>
  export default {
    computed: {
      sortedData(){
        return this.show.data.sort();
      }
    },
    data () {
      return {
        editmode: false,
        fieldform: new Form({
          type_id: null,
          file: null,
        }),
        addform: new Form({
          name: null
        }),
        show: {
          type: null,
          name: null,
          data: []
        },
        fileInputKey2: 0,
        typies: [
          { id: 1, name: 'ПО для обработки'},
          { id: 2, name: 'Специальное ПО (ПО для ввода)'},
          { id: 3, name: 'Хранение ПО'},
          { id: 4, name: 'Печать ПО'},
          { id: 5, name: 'Браузеры'}
        ],
        typies2: [
          { name: 'Исключаемые пользователи', tag: 'EXCLUDE_USERS'},
          { name: 'Исключаемые программы', tag: 'EXCLUDE_PROGRAMS'},
          { name: 'Исключаемые браузеры', tag: 'EXCLUDE_BROWSERS'},
          { name: 'Исключаемые СКЗИ', tag: 'EXCLUDE_SKZI'},
          { name: 'Список браузеров', tag: 'BROWSERS'},
          { name: 'Список СКЗИ', tag: 'SKZI'},
          { name: 'Список СЗИ', tag: 'SZI'},
          { name: 'ПО для обработки', tag: 'OBRABOTKA_PO'},
          { name: 'Специальное ПО (ПО для ввода)', tag: 'SPECIAL_PO'},
          { name: 'Хранение ПО', tag: 'XRANENIE_PO'},
          { name: 'Печать ПО', tag: 'PECHAT_PO'}
        ],
      }
    },
    methods: {
      deleteRecord(name){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
             const data = new FormData();
             data.append('name', name);
             data.append("_method", "put");
             axios.post('/api/protocol/setting/'+this.show.type, data)
             .then((response) => {
               this.SuccessToast();
               this.show.data = response.data;
               this.$Progress.finish();
             })
             .catch(() => {
               this.ErrorToast();
               this.$Progress.fail();
             });
          }
        })
      },
      addRecord(){
        const data = new FormData();
        data.append('name', this.addform.name);
        axios.post('/api/protocol/setting/add/'+this.show.type, data)
        .then((response) => {
         this.SuccessToast();
         this.show.data = response.data;
         this.addform.reset();
         this.$Progress.finish();
        })
        .catch(() => {
         this.ErrorToast();
         this.$Progress.fail();
        });
      },
      viewRecord(type){
        this.addform.reset();
        let name = this.typies2.filter((item) => item.tag === type)[0].name
        axios.get('/api/protocol/setting/'+type).then(({ data }) => {
          this.show.type = type;
          this.show.name = name;
          this.show.data = data;
          $('#editRecord').modal('show');
        });
      },
      importJson(){
        this.$Progress.start();
        const data = new FormData();
        data.append('type_id', this.fieldform.type_id);
        data.append('file', this.fieldform.file);
        axios.post('/api/protocol/setting/json', data)
        .then((response)=>{
          if(!response.data.isvalid){
            Toast.fire({
              icon: 'error',
              title: response.data.error
            });
          }else{
            Swal.fire({
              title: "Данные загружены",
              html: "<p>Загружено новых строк: " + response.data.added + "</p>" + "<p>Пропущено строк: " + response.data.skipped + "</p>",
              confirmButtonText: "Ок",
            });
            $('#addNewRecord').modal('hide');
            // this.SuccessToast();
            this.fileInputKey2++;
            this.fieldform.reset();
          }
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      fileUpload2(e){
        this.fieldform.file = e.target.files[0];
      },
      newRecord(){
        this.fieldform.reset();
        $('#addNewRecord').modal('show');
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },

    },
    created() {
      this.$Progress.start();

      this.$Progress.finish();
    }
  }
</script>
